import type { ModuleFile } from '../../core/modules.ts';

// Módulo «devices»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'devices',
    title: 'Equipos',
    path: 'equipos',
    nav: { group: 'Sistema', label: 'Equipos', icon: '▣', order: 2 },
    load: () => import('./DevicesPage.tsx').then((m) => ({ default: m.DevicesPage })),
  },
];
